import { useDashboardContext } from "../contexts/dashboard-context";
import { useDefinition } from "./useDefinition";

export const useSupportedProductStartDate = (): "month" | "year" | undefined => {
	const definition = useDefinition();
	const dashboard = useDashboardContext();

	if (!definition || !definition.startMonth) return undefined;
	if (!dashboard.canApplyStartMonth(definition.startMonth)) {
		return undefined;
	}

	switch (definition.allowVariableStart) {
		case eXpress.core.StartType.Year:
			return "year";
		case eXpress.core.StartType.Month:
			return "month";
		default:
			return undefined;
	}
};
